import type { GetAppIntegrationUsersParams } from '../../-query/type';
export const TAB_FILTER = {
  FOLLOWING: 'FOLLOWING',
  NO_WORKER: 'NO_WORKER',
  VIOLATED: 'VIOLATED',
  VIOLATED_ROLE: 'VIOLATED_ROLE',
  NO_GROUP: 'NO_GROUP',
  VIOLATED_GROUP: 'VIOLATED_GROUP',
  NO_USER: 'NO_USER',
  INACTIVE: 'INACTIVE',
  ALUMNI: 'ALUMNI',
  ALL: 'ALL'
} as const;
export type TAB_FILTER = (typeof TAB_FILTER)[keyof typeof TAB_FILTER];
export type ORDER_BY_FILTER = Exclude<GetAppIntegrationUsersParams['orderBy'], undefined>;
export const SortColumns = {
  APP: 'APP',
  USER: 'USER',
  PERSON: 'PERSON',
  CREATED_AT: 'CREATED_AT',
  DEACTIVATED_AT: 'DEACTIVATED_AT',
  LAST_SIGNED_IN_AT: 'LAST_SIGNED_IN_AT',
  APP_USER_ROLE: 'APP_USER_ROLE',
  APP_ASSIGNED_ROLE: 'APP_ASSIGNED_ROLE',
  APP_USER_STATUS: 'APP_USER_STATUS',
  INTERNAL_STATUS: 'INTERNAL_STATUS'
} as const satisfies Record<string, ORDER_BY_FILTER>;
export const ColumnsToSortColumns = {
  app: 'APP',
  user: 'USER',
  person: 'PERSON',
  roleName: 'APP_USER_ROLE',
  assignedRoleName: 'APP_ASSIGNED_ROLE',
  statusName: 'APP_USER_STATUS',
  activeStatus: 'INTERNAL_STATUS',
  createdAt: 'CREATED_AT',
  deactivatedAt: 'DEACTIVATED_AT',
  lastSignedInAt: 'LAST_SIGNED_IN_AT'
} as const satisfies Record<string, ORDER_BY_FILTER>;
export const SortColumnsToColumns = {
  APP: 'app',
  USER: 'user',
  PERSON: 'person',
  APP_USER_ROLE: 'roleName',
  APP_ASSIGNED_ROLE: 'assignedRoleName',
  APP_USER_STATUS: 'statusName',
  INTERNAL_STATUS: 'activeStatus',
  BILLING_ACTIVE: 'billingActive',
  CREATED_AT: 'createdAt',
  DEACTIVATED_AT: 'deactivatedAt',
  LAST_SIGNED_IN_AT: 'lastSignedInAt',
  LOGIN_ID: 'user.loginId'
} as const satisfies Record<ORDER_BY_FILTER, string>;